module.exports = __webpack_public_path__ + "assets/images/c1abe09b53d37a7bfa7130e792d79b27.png";